import ApiClient from './ApiClient';

class AccountBusinessHoursAPI extends ApiClient {
  constructor() {
    super('account_business_hours', { accountScoped: true });
  }
}

export default new AccountBusinessHoursAPI();
